import { systemIds } from '@/shared/utils';
const commonFunc = (path) => {
    return {
        path: path,
        systemId: systemIds['project'], // 为了获取基础路由
    };
};
export const projectToPathNameMap = {
    // 代办跳转
    project1000: ({ businessKey }) => commonFunc(`/list/details?id=${businessKey}`),
    project3000: ({ businessKey }) => commonFunc(`/projectDivision/detail?id=${businessKey}`),
    project5000: ({ businessKey }) => commonFunc(`/projectUnitChange/detail?id=${businessKey}`),
    project6000: ({ businessKey }) => commonFunc(`/commence/detail?id=${businessKey}`),
    project2000: ({ businessKey }) => commonFunc(`/changeApply/detail?id=${businessKey}`),
    project1010: ({ businessKey }) => commonFunc(`/list/details?id=${businessKey}`),
};
